export default __webpack_public_path__ + "c778091.png";